import request from '@/utils/request'

export const getUserOtaInfo = (userId: string) =>
  request({ url: `/admin/users/${userId}/ota`, method: 'get' })

export const setUserOtaOverride = (
  userId: string,
  otaFileId: number,
  reason?: string,
  deviceSerial?: string,
  applyToAllDevices?: boolean
) =>
  request({
    url: `/admin/users/${userId}/ota-override`,
    method: 'put',
    data: { otaFileId, reason, deviceSerial, applyToAllDevices: applyToAllDevices === true }
  })

export const clearUserOtaOverride = (
  userId: string,
  deviceSerial?: string,
  applyToAllDevices?: boolean
) => {
  // User-scope pin (device_serial_number=NULL) için applyToAllDevices=true.
  // Spesifik cihaz pini için deviceSerial. İkisi de yoksa backend primary
  // cane fallback'i çalışır (eski "Pin'i kaldır" davranışı).
  const params: any = {}
  if (applyToAllDevices) params.applyToAllDevices = true
  else if (deviceSerial) params.deviceSerial = deviceSerial
  return request({
    url: `/admin/users/${userId}/ota-override`,
    method: 'delete',
    params: Object.keys(params).length ? params : undefined
  })
}

export const listUserOtaOverrides = (params: {
  page?: number
  pageSize?: number
  otaFileId?: number
  deviceSerial?: string
  search?: string
}) =>
  request({ url: '/admin/user-ota-overrides', method: 'get', params })

// Targets are exact (userId, deviceSerialNumber) pairs. deviceSerialNumber
// null addresses the user-scope pin, so clearing a per-cane pin never takes
// out the account-wide one by accident.
export const bulkClearUserOtaOverrides = (
  targets: Array<{ userId: string; deviceSerialNumber: string | null }>
) =>
  request({
    url: '/admin/user-ota-overrides/bulk-clear',
    method: 'post',
    data: { targets },
    timeout: 120000
  })
